var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"conteneur-page gradient-bleu align-start heritage-scroll",attrs:{"fluid":"","fill-height":"","pa-2":""}},[_c('timeline-pointages',{attrs:{"type":"projets"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }